import { Center, Text3D, MeshTransmissionMaterial } from "@react-three/drei";

export default function Text({
  children,
  config,
  font = "fonts/Inter_Bold.json",
  color,
  ...props
}) {
  return (
    <>
      <group>
        <Center scale={[0.8, 1, 1]} front top {...props}>
          {/* curveSegments 24 / bevelSegments 3: these labels render at
              scale 0.2, where 128/10 was ~300ms of extra main-thread
              tessellation across the five labels for no visible gain. */}
          <Text3D
            castShadow
            bevelEnabled
            font={font}
            scale={5}
            letterSpacing={-0.03}
            height={0.25}
            bevelSize={0.01}
            bevelSegments={3}
            curveSegments={24}
            bevelThickness={0.01}
          >
            {children}
            {/* <MeshTransmissionMaterial {...config} /> */}
            <meshStandardMaterial color={color} />
          </Text3D>
        </Center>
      </group>
    </>
  );
}
